/**
 * Basket settings API client (BFF: `/api/v1/store/settings/basket`).
 *
 * Cart lifetime, limits and guest-merge behaviour (→ web-basket-service).
 */
import { apiClient } from '@/shared/api';
import type { BasketSettings, UpdateBasketSettingsRequest } from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/basket';

export const getBasketSettings = async (): Promise<BasketSettings> =>
  (await apiClient.get<BasketSettings>(BASE)).data;

export const updateBasketSettings = async (
  body: UpdateBasketSettingsRequest,
): Promise<BasketSettings> => (await apiClient.put<BasketSettings>(BASE, body)).data;
